"use client";

import { useContext, useState } from "react";
import { UserContext } from "@/contexts/user-context";
import { HandIcon } from "lucide-react";
import {
  DoctorPickOpenSpecializationHome,
  checkDoctorIsWithoutSpecialization,
} from "@/components/common/doctor-pick-open-specialization/doctor-pick-open-specialization-nav-profile";
import { DoctorPickWorkplacesHome } from "@/components/common/doctor-pick-workplaces/doctor-pick-workplaces-home";
import { StudentYearPromptHomeChip } from "@/components/common/student-year-prompt/student-year-prompt";
import { PracticeExamCountdown } from "@/components/exams/practice-exam/practice-exam-countdown";

export const HomeDashboardHello = ({
  practiceExamStatus, // widgetSlots,
}: {
  practiceExamStatus: ExamPracticeExamStatusVM;
  // widgetSlots: HomeDashboardSlot[];
}) => {
  const { displayName, keyType, dataForType } = useContext(UserContext);

  const isPracticeExamCountdownVisible =
    practiceExamStatus.isSubscribed && !!practiceExamStatus.startDate;

  const [isRightSideEmptyOnMount] = useState(
    () =>
      !isPracticeExamCountdownVisible &&
      !checkDoctorIsWithoutSpecialization(keyType, dataForType),
  );

  return (
    <header className={"mb-4 flex flex-col justify-between gap-6 md:flex-row"}>
      <div className={"flex items-center gap-4"}>
        <div
          className={
            "flex items-center justify-center rounded-lg bg-zinc-100 p-1.5"
          }
        >
          <HandIcon size={24} className={`rotate-33`} />
        </div>
        <h1 className={`text-foreground text-2xl font-semibold`}>
          Cześć, {displayName?.split(" ")[0]}
        </h1>
      </div>
      <div className="flex flex-col gap-2 empty:hidden lg:flex-row lg:items-center">
        {isPracticeExamCountdownVisible && (
          <PracticeExamCountdown practiceExamStatus={practiceExamStatus} />
        )}
        {/* <KsefInfaktCountdown /> */}
        <DoctorPickOpenSpecializationHome />
        <StudentYearPromptHomeChip />
        {isRightSideEmptyOnMount && <DoctorPickWorkplacesHome />}
      </div>
    </header>
  );
};
